import Router from "next/router";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { resolvePathFromOrchestratorState } from "./resolvePathFromOrchestratorState";
import { IExtendedOnboardingOrchestratorState } from "./types";

type Query = {
  [key in IExtendedOnboardingOrchestratorState]?: Record<string, string>;
};

interface IRedirectToOrchestratorStateProps {
  state: IExtendedOnboardingOrchestratorState;
  mode: IOfferMode;
  query?: Query;
}

export function redirectToOrchestratorState({
  state,
  mode,
  query,
}: IRedirectToOrchestratorStateProps) {
  Router.push({
    pathname: resolvePathFromOrchestratorState(state),
    query: query ? { ...query[state], mode } : { mode },
  });
}
